import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { UserProfileMetadata } from 'util/resources';
import { UserProfileMetadataResource } from 'util/resources/UserProfileMetadata';

export const fetchUserProfileMetadata = createAsyncThunk(
  'userProfileMetadata/fetch',
  async (userProfileIds: string[] = []) => {
    const metadata = await UserProfileMetadata.where({ user_profile_ids: userProfileIds })
      .includes('interview')
      .all();
    return metadata.toArray();
  },
);

export const fetchOneUserProfileMetadata = createAsyncThunk(
  'userOneProfileMetadata/fetch',
  async (userProfileId: string) => {
    const metadata = await UserProfileMetadata.where({ user_profile_ids: [userProfileId] })
      .includes('interview')
      .all();

    const data = metadata.toArray();

    return data[0];
  },
);

interface State {
  items: UserProfileMetadataResource[];
  loading: boolean;
  loaded: boolean;
  error: any;
}

const slice = createSlice({
  name: 'userProfileMetadata',
  initialState: {
    items: [],
    loading: false,
    loaded: false,
    error: null,
  } as State,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUserProfileMetadata.rejected, (state, action) => {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    });
    builder.addCase(fetchUserProfileMetadata.fulfilled, (state, action) => {
      return {
        ...state,
        items: action.payload,
        loaded: true,
        loading: false,
        error: null,
      };
    });
    builder.addCase(fetchUserProfileMetadata.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(fetchOneUserProfileMetadata.rejected, (state, action) => {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    });
    builder.addCase(fetchOneUserProfileMetadata.fulfilled, (state, action) => {
      let items = cloneDeep(state.items) as UserProfileMetadataResource[];
      const index = items.findIndex((item) => item.id === action.payload.id);

      if (index !== -1) {
        items[index] = action.payload;
      } else {
        items.push(action.payload);
      }

      return {
        ...state,
        items,
        loaded: true,
        loading: false,
        error: null,
      };
    });
    builder.addCase(fetchOneUserProfileMetadata.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export default slice;
